import React from "react";

import { capitalize } from "lodash";

import UmpireRating from "./UmpireRating";

import { useGameSummaryContext } from "../contexts/GameSummary";
import { umpireRatingOptions } from "../lib/constants";

const UmpireInfo = (): React.JSX.Element => {
    const { game, umpireRatings } = useGameSummaryContext();

    return (
        <section className="umpireDetails" data-testid="umpireDetails">
            <h3>Umpire Info</h3>
            <div>
                <div className="bg-body-primary heading">
                    {game.umpires
                        ? "* To rate an Umpire, please click on the appropriate star Rating"
                        : "No registered umpires"}
                </div>

                <div className="bg-body-secondary umpireInfo">
                    {Object.keys(umpireRatingOptions).map((location, idx) => {
                        const umpireInfo = game.umpires?.find(
                            u => u.location === location,
                        );
                        const ratedUmpire = umpireRatings.find(
                            r => r.umpire.id === umpireInfo?.id,
                        );

                        return (
                            umpireInfo && (
                                <div className={`umpire ${location}`} key={idx}>
                                    <b>{capitalize(location)} Umpire</b>
                                    {umpireInfo.name}
                                    <br />
                                    <span>
                                        <a href={`mailto:${umpireInfo.email}`}>
                                            {umpireInfo.email}
                                        </a>
                                    </span>
                                    tel: {umpireInfo.phone}
                                    <UmpireRating
                                        location={
                                            location as keyof typeof umpireRatingOptions
                                        }
                                        umpire={umpireInfo}
                                        ratedUmpire={ratedUmpire}
                                    />
                                </div>
                            )
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default UmpireInfo;
